import React, { useContext } from 'react';
import CharacterClassSelector from './CharacterClassSelector';
import { AuthContext } from '../context/AuthContext';
import './OnboardingClassModal.css';

export default function OnboardingClassModal({ onSuccess }) {
  const { refreshUser } = useContext(AuthContext);

  const handleSelect = async (classId) => {
    if (refreshUser) {
      await refreshUser();
    }
    if (onSuccess) {
      onSuccess(classId);
    }
  };

  return (
    <div className="onboarding-modal-overlay">
      <div className="onboarding-modal-content">
        <h2 className="onboarding-modal-title">Selecciona tu Clase</h2>
        <p className="onboarding-modal-description">
          Elige tu especialización en la Red Q. Esta decisión afectará tu experiencia y estilo de juego.
        </p>
        <CharacterClassSelector currentClass={null} onSelect={handleSelect} />
      </div>
    </div>
  );
}
